import { Dropdown } from '@design-system';
import { useGetOperatorsMutation } from '@services/operators/operators.endpoints';
import { useEffect } from 'react';

export type OperatorDropdownProps = {
    onChangeAction: (userId: string) => void;
    valueKey: 'id' | 'label';
    value: string | null;
    canCreate?: boolean;
};

export const OperatorDropdown: React.FC<OperatorDropdownProps> = ({ onChangeAction, valueKey, value, canCreate }) => {
    const [getOperators, { isLoading: isLoadingGetOperators, data: getOperatorsData }] = useGetOperatorsMutation();

    useEffect(() => {
        getOperators();
    }, [getOperators]);

    const options = getOperatorsData?.map((operator) => ({ id: operator.id_operator, label: operator.name })) ?? [];

    // Trouver l'option correspondant à la valeur
    const selectedOption = value
        ? options.find((opt) => opt[valueKey] === value) || (canCreate && valueKey === 'label' ? { id: '', label: value } : null)
        : null;

    return (
        <Dropdown
            options={options}
            placeholder="Nom du conducteur de travaux"
            disabled={isLoadingGetOperators}
            canCreate={canCreate}
            className="mb-small-spacing"
            isSearchable
            value={selectedOption}
            onOptionChange={(option) => {
                if (option.id === '' && option.label) {
                    onChangeAction(option.label);
                } else {
                    onChangeAction(option[valueKey]);
                }
            }}
        />
    );
};
